import React from 'react';

import { ContainerMdal } from './style';
import './style.css';

function Modal({ open, onClose, link }) {
  const handleClickOutside = (e) => {
    if (e.target === e.currentTarget) {
      onClose(); // Fecha o modal ao clicar fora.
    }
  };

  if (!open) return null;
  return (
    <ContainerMdal onClick={handleClickOutside}>
      <iframe
        title="Video do Segala e Ricardo"
        width="560"
        height="315"
        src={link}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </ContainerMdal>
  );
}

export default Modal;
